import { Component, Inject, OnInit, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

import { FileResource, Document } from 'app/shared/modules/folders/folders.types';
import { Subject } from 'rxjs';
import { Account } from 'app/core/models/account.types';
import { AccountService } from 'app/core';
import { SharedResourcesService } from 'app/modules/shared-resources/shared-resources.service';

@Component({
  selector: 'shared-resource-view-file',
  templateUrl: './view-file.component.html',
  styleUrls: ['./view-file.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SharedResourceViewFileComponent implements OnInit {
  selectedFile: FileResource;
  selectedDocument: Document;

  documentVersionsDataSource: MatTableDataSource<any>;
  documentVersionsColumns: string[];

  private _unsubscribeAll: Subject<void>;
  account: Account;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<SharedResourceViewFileComponent>,
    private _sharedResourcesService: SharedResourcesService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _accountService: AccountService,
  ) {
    this.documentVersionsDataSource = new MatTableDataSource();
    this.documentVersionsColumns = ['version', 'created_by', 'created_at', 'actions'];

    this._unsubscribeAll = new Subject();

    this._accountService.currentAccount.subscribe((accountData) => {
      this.account = accountData;
    });
  }

  ngOnInit(): void {
    this.selectedFile = this.data.fileResource;
    this.setSelectedDocument();
    this.loadFile();
  }

  setSelectedDocument(document?): void {
    if (document) {
      this.selectedDocument = document;
    } else {
      if (this.selectedFile.documents.length > 0) {
        this.selectedDocument = this.selectedFile.documents[0];
      }
    }
  }

  loadFile(): void {
    this._sharedResourcesService
      .getFile(this.selectedFile.folder_resource_id, this.selectedFile.id)
      .subscribe((fileResource) => {
        this.documentVersionsDataSource.data = fileResource.documents.sort((a, b) => (a.id < b.id ? 1 : -1));
        this._changeDetectorRef.markForCheck();
      });
  }

  downloadDocument(document): void {
    window.open(document.original_url, '_blank');
  }

  /**
   * Discard the message
   */
  discard(): void {
    this.matDialogRef.close();
  }

  /**
   * Track by function for ngFor loops
   *
   * @param index
   * @param item
   */
  trackByFn(index: number, item: any): any {
    return item.id || index;
  }
}
